(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
      var coll = document.getElementsByClassName("footer-collapsible");
    var i;

    for (i = 0; i < coll.length; i++) {
      coll[i].addEventListener("click", function() {
        this.classList.toggle("active");
        var content = this.nextElementSibling;
        if (content.style.maxHeight){
          content.style.maxHeight = null;
        } else {
          content.style.maxHeight = content.scrollHeight + "px";
        }
      });
    }


    var cont = document.getElementsByClassName("footer-content");
    var i;

    for (i = 0; i < cont.length; i++) {
      cont[i].addEventListener("click", function() {
        this.classList.toggle("active");
        var content = this.nextElementSibling;
        if (content.style.maxHeight){
          content.style.maxHeight = null;
        } else {
          content.style.maxHeight = content.scrollHeight + "px";
        }
      });
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const copyButton = document.getElementById('copyCoupon');
    const couponInput = document.getElementById('couponCode');
    const copyMessage = document.getElementById('copyMessage');

    if (copyButton && couponInput) {
      copyButton.addEventListener('click', function() {
        // Seleziona e copia il testo
        couponInput.select();
        couponInput.setSelectionRange(0, 99999); // Per mobile
        
        // Copia negli appunti
        navigator.clipboard.writeText(couponInput.value).then(function() {
          // Rimuovi la selezione blu
          couponInput.blur();
          window.getSelection().removeAllRanges();
          
          // Mostra il messaggio di successo
          copyMessage.style.display = 'block';
          
          // Nascondi il messaggio dopo 3 secondi
          setTimeout(function() {
            copyMessage.style.display = 'none';
          }, 3000);
        }).catch(function(err) {
          console.error('Errore nella copia:', err);
        });
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
